module.exports = "/_next/static/images/33ccea2ace1cf3159bd00d3ac19e154b-2-cards@0.75x.jpg";